module.exports = __webpack_public_path__ + "static/media/test16_2.edbdc7fa.png";